import { Clients } from '../../types/enums';

export const dscrPropertyType = {
  title: "Property Type",
  key: "propertyType",
  fields: [
    {
      key: "singleFamilyDetatchedText",
      label: "singleFamilyDetatchedText",
      value: "Single Family/Detached",
      type: "button",
    },
    {
      key: "24UnitText",
      label: "24UnitText",
      value: "2-4 Unit",
      type: "button",
    },
    {
      key: "condoText",
      label: "condoText",
      value: "Condo",
      type: "button",
    },
    {
      key: "townHomeText",
      label: "townHomeText",
      value: "Towhome",
      type: "button",
    },
  ],
};

export const bridgePropertyType = {
  title: "Property Type",
  key: "propertyType",
  fields: [
    {
      key: "singleFamilyDetatchedText",
      label: "singleFamilyDetatchedText",
      value: "Single Family/Detached",
      type: "button",
    },
    {
      key: "24UnitText",
      label: "24UnitText",
      value: "2-4 Unit",
      type: "button",
    },
    {
      key: "condoText",
      label: "condoText",
      value: "Condo",
      type: "button",
    },
    {
      key: "multiFamilyMixedUseText",
      label: "multiFamilyMixedUseLabel",
      value: "Multifamily/MixedUse",
      type: "button"
    },
    {
      key: "townHomeText",
      label: "townHomeText",
      value: "Towhome",
      type: "button",
    },
  ],
};

export const mmtcBridgeGUCPropertyType = bridgePropertyType;

export const mmtcBridgePropertyType = {
  title: "Property Type",
  key: "propertyType",
  fields: [
    // {
    //   key: "singleFamilyDetatchedText",
    //   label: "singleFamilyDetatchedText",
    //   value: "Single Family/Detached",
    //   type: "button",
    // },
    // {
    //   key: "24UnitText",
    //   label: "24UnitText",
    //   value: "2-4 Unit",
    //   type: "button",
    // },
    // {
    //   key: "condoText",
    //   label: "condoText",
    //   value: "Condo",
    //   type: "button",
    // },
    {
      key: "multiFamilyMixedUseText",
      label: "multiFamilyMixedUseLabel",
      value: "Multifamily/MixedUse",
      type: "button"
    },
    // {
    //   key: "townHomeText",
    //   label: "townHomeText",
    //   value: "Towhome",
    //   type: "button",
    // },
  ],
};

export const loanType = {
  title: "Loan Type",
  key: "loanType",
  fields: [
    {
      key: "fixFlipText",
      label: "fixFlipText",
      value: "Fix & Flip",
      type: "button",
    },
    {
      key: "stabilizedText",
      label: "stabilizedText",
      value: "Stabilized",
      type: "button",
    },
    {
      key: "groundUpText",
      label: "groundUpText",
      value: "Ground Up",
      type: "button",
    },
  ]
};

export const sizingType = {
  title: "Sizing Type",
  key: "sizingType",
  fields: [
    // {
    //   key: "quickLoanSizing",
    //   label: "quickLoanSizing",
    //   value: "Quick Loan Sizing",
    //   type: "button",
    // },
    {
      key: "detialedLoanSizing",
      label: "detialedLoanSizing",
      value: "Detailed Loan Sizing",
      type: "button",
    }
  ]
}

// TD: Add the following to the productTypeConfig function when using the roles from account map data
// disable: isOriginator ? !roles?.includes(newLoanTypes?.dscrLoan) && !userPermissions?.includes("create_dscr") : !userPermissions?.includes("create_dscr"),
// disable: isOriginator ? !roles.includes(newLoanTypes?.bridgeLoan) && !userPermissions.includes("create_bridge") : !userPermissions.includes("create_bridge"),

export const productTypeConfig = (roles: string[], isOriginator?: boolean, userPermissions?: any) => [
  {
    field: "Bridge Loan",
    label: "bridgeLoanLabel",
    key: "bridgeLoan",
    type: "button",
    disable: !roles.includes("create_bridge"),
    isVisible: (props: any) =>  props?.realm === Clients.BPL_SIZER,
    subFields: [loanType, bridgePropertyType],
  },
  {
    field: "Bridge Loan",
    label: "bridgeLoanLabel",
    key: "bridgeLoan",
    type: "button",
    disable: !roles.includes("create_bridge"),
    isVisible: (props: any) =>  {
      return props?.client === Clients.MMTC;
    },
    subFields: [loanType, mmtcBridgePropertyType],
  },
  {
    field: "Investor DSCR",
    label: "investorDSCR",
    key: "investorDSCR",
    type: "button",
    disable: !roles?.includes("create_dscr"),
    isVisible: (props: any) => props?.realm === Clients.BPL_SIZER,
    subFields: [dscrPropertyType],
  },
  {
    field: "Investor DSCR",
    label: "investorDSCR",
    key: "investorDSCR",
    type: "button",
    disable: !roles?.includes("create_dscr"),
    isVisible: (props: any) => props?.showSizingType , // Clients.MMTC
    subFields: [dscrPropertyType, sizingType],
  },
 
];
